
 <template>
  <div>
    <el-row class="form-title">
      交易流水
    </el-row>
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="80px">
      <el-form-item label="变动类型" prop="type">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="交易时间" prop="tareWeightTime">
        <el-date-picker
          v-model="form.tareWeightTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="协议编码" prop="agreementCode">
        <el-input v-model="form.agreementCode" placeholder="请输入协议编码"></el-input>
      </el-form-item>
      <el-form-item label="客户名称" prop="customerName">
        <el-input v-model="form.customerName" placeholder="请输入协议编码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
        <el-button type="primary" @click="handleExport" class="export-btn">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table border :data="tableData" tooltip-effect="light">
      <el-table-column
        prop="code"
        label="流水号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="customerName"
        label="客户名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="agreementCode"
        label="协议编号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="actualRebateTonnage"
        label="实际返利吨数"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="returnTonnage"
        label="返还吨数"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="typeName"
        label="变动类型"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="changeAmount"
        label="金额"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="tradeTime"
        label="交易时间"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="expiredTime"
        label="到期时间"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="businessNo"
        label="关联单据"
        :show-overflow-tooltip="true">
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :current-page="listState.pageNo"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange">
    </el-pagination>
    <el-row>
      <el-button @click="handleClose">返 回</el-button>
    </el-row>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'differentiatedMarketingFlow',
  data () {
    return {
      rebateAccountId: '',
      form: {
        tareWeightTime: [],
        agreementCode: '',
        customerName: ''
      },
      typeList: [
        { value: '', label: '全部' },
        { value: 1, label: '增加' },
        { value: 2, label: '下单扣减' },
        { value: 3, label: '手动增加' },
        { value: 4, label: '手动扣减' },
        { value: 5, label: '到期失效' },
        { value: 6, label: '失效释放' },
        { value: 7, label: '退款返还' },
        { value: 8, label: '协议使用返利' },
        { value: 9, label: '协议审核不通过返还' },
        { value: 10, label: '变更协议使用' },
        { value: 11, label: '变更协议不通过返还' },
        { value: 12, label: '变更协议返还' },
        { value: 13, label: '变更协议不通过使用' },
        { value: 14, label: '协议结束返还' }
      ],
      detailData: {},
      tableData: [],
      total: 0,
      listState: {
        pageNo: 1,
        pageSize: 10
      }
    }
  },
  computed: { },
  mounted () {
    this.id = this.$route.query.id
    this.queryDetail()
    this.handleSearch()
  },
  methods: {
    ...mapActions(['rebateAccountInfoDm', 'rebateAccountDetailPageDm', 'exportRebateAccountDetailDm']),
    queryDetail () {
      this.rebateAccountInfoDm({ id: this.id }).then(res => {
        if (res.success) {
          this.detailData = res.data
        }
      })
    },
    // 搜索
    handleSearch () {
      const params = {
        rebateAccountId: this.id,
        ...this.listState
      }
      if (this.form.type) params.type = this.form.type
      if (this.form.tareWeightTime === null) {
        console.log(this.form.tareWeightTime)
        this.form.tareWeightTime = []
      }
      if (this.form.tareWeightTime && this.form.tareWeightTime.length === 2) {
        params.tradeStartTime = this.form.tareWeightTime[0] + ' 00:00:00'
        params.tradeEndTime = this.form.tareWeightTime[1] + ' 23:59:59'
        console.log(params)
      }
      if (this.form.agreementCode) params.agreementCode = this.form.agreementCode
      if (this.form.customerName) params.customerName = this.form.customerName
      this.rebateAccountDetailPageDm(params).then(res => {
        if (res.success) {
          const { list = [], total, pageNum, pageSize } = res.data
          this.tableData = list
          this.total = total
          this.listState.pageNo = pageNum
          this.listState.pageSize = pageSize
        }
      })
    },
    // 查询表单，表格重置
    handleReset () {
      this.form.pageNo = 1
      this.form.pageSize = 10
      this.form.type = ''
      this.$refs['form'].resetFields()
      this.handleSearch()
    },
    // 分页条数变更
    handleSizeChange (val) {
      console.log(val)
      this.listState.pageSize = val
      this.handleSearch()
    },
    // 分页跳转
    handleCurrentChange (val) {
      console.log(val)
      this.listState.pageNo = val
      this.handleSearch()
    },
    handleClose () {
      this.$router.go(-1)
    },
    handleExport () {
      this.exportRebateAccountDetailDm({ ...this.form, rebateAccountId: this.id }).then((res) => {
        function createDownloadFile () {
          let blob = new Blob([res])
          let link = document.createElement('a')
          link.download = '交易流水.xls'
          link.style.display = 'none'
          link.target = '_Blank'
          link.href = window.URL.createObjectURL(blob)
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(link.href)
        }
        createDownloadFile()
        this.$message.success('导出成功')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-input, .form-select, .el-input-number {
  width: 200px;
}

.img-upload {
  height: 148px;
}
.form-title {
  font-weight: bold;
  margin-bottom: 20px;
}
.export-btn{
  float: right;
}
</style>
